import {
  Component,
  AfterViewInit,
  ViewChild,
  ViewChildren
} from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import {
  FormGroup,
  FormArray,
  FormBuilder,
  Validators,
  FormControl
} from "@angular/forms";
import { AppConfig } from "../config/app.config";
import { AbstractControl } from "@angular/forms";
import { CRMService } from "../services/crm.service";
import { ValidationErrors } from "@angular/forms";
import { Observable, of } from "rxjs";
import { AsyncValidatorFn } from "@angular/forms";

/*
  Custom validators to use everywhere.
*/
// FORM GROUP VALIDATORS
export function matchingPasswords(passwordKey: string, cpasswordKey: string) {
  return (group: FormGroup): { [key: string]: any } => {
    let password = group.controls[passwordKey];
    let cpassword = group.controls[cpasswordKey];

    if (password.value !== cpassword.value) {
      return {
        mismatchedPasswords: true
      };
    }
  };
}

export function requiredTrim(fieldControl: FormControl) {
  return !fieldControl.value ||
    (typeof fieldControl.value == "string" && fieldControl.value.trim() == "")
    ? { requiredTrim: true }
    : null;
}

export function ipRange(fieldControl: FormControl) {
  let ips = fieldControl.value.split("-");
  let ipPattern = /^(\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b)$/;
  if (ips.length == 2) {
    if (ipPattern.test(ips[0]) && ipPattern.test(ips[1])) {
      let ip1 = ips[0].split(".");
      let ip2 = ips[1].split(".");
      if (
        ip1[0] == ip2[0] &&
        ip1[1] == ip2[1] &&
        ip1[2] == ip2[2] &&
        parseInt(ip1[3]) < parseInt(ip2[3])
      ) {
        return null;
      } else {
        return { ipRange: true };
      }
    } else {
      return { ipRange: true };
    }
  } else {
    return null;
  }
}

export function chkDuplicateIp(fieldControl: FormControl) {
  let ips = fieldControl.value.limit_iP_access;
  if (ips.length > 1) {
    var uniqueArray = ips.filter(function(a: any) {
      if (!this[a["ip"]] || a["ip"].trim() == "") {
        return (this[a["ip"]] = true);
      }
    }, Object.create(null));

    if (ips.length == uniqueArray.length) {
      return null;
    } else {
      return { chkDuplicateIp: true };
    }
  } else {
    return null;
  }
}

export function ZipValidator(fieldControl: FormControl) {
  //let zipUS = /^[0-9]{5}(?:-[0-9]{4})?$/;
  let zip = fieldControl.value;
  if (zip.length < 4 || zip.length > 6) {
    return { zipError: true };
  } else return null;
  // return zipUS.test(zip) ? null : {
  //   'zipError': true
  // }
}

export function WhiteSpaceValidator(control: FormControl) {
  //console.log("trimmed value ",control.value.trim());
  if (control.value.trim().length < 1) {
    return { required: true };
  } else return null;
}

export function DateValidator(control: FormControl) {
  const dateRegEx = new RegExp(/^\d{1,2}\.\d{1,2}\.\d{4}$/);
  return dateRegEx.test(control.value) ? null : { date: true };
}

export function PhoneNumberValidator(control: FormControl) {
  let phoneNumber = control.value.trim();
  control.value.trim();
  if (phoneNumber.length < 10 || phoneNumber.length > 15) {
    return { phone: null };
  } else return null;
}

export function VatValueValidator(control: FormControl) {
  let vat = parseInt(control.value);
  if (vat < 0 || vat > 21) {
    console.log("Vat ", vat);
    return { range: null };
  } else return null;
}

export function positiveNumber(control: FormControl) {
  let number = parseInt(control.value);
  if (!number) {
    return { required: null };
  }
  if (number < 0) {
    return { range: null };
  } else return null;
}

export function NumberValidator(control: FormControl) {
  if(!control.value || !control.value.length){
    return null;
  }
  var numRegexp = /^\d+(\.\d{1,2})?$/;
  let val = control.value;
  return numRegexp.test(val) ? null : { number: true };
}

// Validators.pattern(/^[-+]?([1-9]{1}\d*|0{1})(\.?)(?(2)\d+)$/)
